<ng-container *ngIf="loading; else opportunityTags">
  <glxy-loading-spinner [fullWidth]="true"></glxy-loading-spinner>
</ng-container>

<ng-template #opportunityTags>
  <ng-container *ngIf="(hasTags$ | async) === false; else tagContent">
    <glxy-empty-state>
      <glxy-empty-state-hero>
        <mat-icon>local_offer</mat-icon>
      </glxy-empty-state-hero>
      <p>
        {{ 'FRONTEND.SALES_UI.OPPORTUNITY_TAGS.EMPTY_STATE.DESCRIPTION' | translate }}
      </p>
      <glxy-empty-state-actions>
        <button mat-stroked-button (click)="openEditTagsDialog()">
          {{ 'FRONTEND.SALES_UI.OPPORTUNITY_TAGS.EMPTY_STATE.ACTION' | translate }}
        </button>
      </glxy-empty-state-actions>
    </glxy-empty-state>
  </ng-container>
</ng-template>

<ng-template #tagContent>
  <div class="tags-container">
    <mat-chip-set class="tags-list">
      <mat-chip *ngFor="let tag of tags$ | async">
        {{ tag.name }}
      </mat-chip>
    </mat-chip-set>
    <button mat-icon-button (click)="openEditTagsDialog()">
      <mat-icon>edit</mat-icon>
    </button>
  </div>
</ng-template>
